<div class="w-screen h-screen max-h-screen flex">
 <app-general-sidebar></app-general-sidebar>
  <section class="max-h-screen grow grid grid-rows-[auto_1fr]">
    <app-logged-in-header></app-logged-in-header>
    <main class="bg-slate-50 overflow-auto">
        <router-outlet></router-outlet>
    </main>
  </section>
</div>